import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Eye, Save } from "lucide-react";

import { Footer as FooterSections } from "./templates/Footer";
import { FormActions } from "../../components/FormField";

import {
  server_post_data,
  dynamic_page_save_update,
  get_dynamic_page_detail,
} from "../../serviceconnection/ServiceConnection";
import { showSuccess, showError, showSeoWarnings } from "../../lib/toast";

export function FooterCMS() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [pageId, setPageId] = useState(0);
  const [initialData, setInitialData] = useState(null);

  const sectionsRef = useRef({});

  const fetchFooter = async () => {
    try {
      const listRes = await server_post_data(get_dynamic_page_detail, {
        main_id: 0,
      });
      const list = listRes.data?.data || [];
      const record = list.find((p) => p.page_type === "footer");
      if (!record) return;

      const detailRes = await server_post_data(get_dynamic_page_detail, {
        main_id: record.id,
      });
      const d = detailRes.data?.data || {};
      setPageId(d.id || 0);
      const sections = d.sections_data?.sections || d.sections_data || {};
      setInitialData(sections);
    } catch (err) {
      console.error("Failed to fetch footer:", err);
    }
  };

  useEffect(() => {
    fetchFooter();
  }, []);

  const handleSave = async () => {
    try {
      setLoading(true);
      const payload = {
        p_id: pageId,
        page_name: "Footer",
        page_type: "footer",
        category: "",
        uuid: Date.now().toString(),
        seo_id: 0,
        sections: sectionsRef.current,
        seo: {},
      };
      const saveRes = await server_post_data(dynamic_page_save_update, payload);
      showSuccess("Footer saved successfully");
      showSeoWarnings(saveRes);
      navigate("/pages")
    } catch (err) {
      console.error(err);
      showError("Error saving footer");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-[900px] mx-auto space-y-5">
      <div className="page-header">
        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate("/pages")}
            className="w-8 h-8 rounded-lg flex items-center justify-center hover:bg-muted text-muted-foreground"
          >
            <ArrowLeft className="w-4 h-4" />
          </button>
          <div>
            <h1 className="page-title">Footer CMS</h1>
            <p className="page-subtitle">
              Edit footer links, contact info & social media
            </p>
          </div>
        </div>
        <button className="flex items-center gap-2 text-sm font-medium text-muted-foreground border border-border rounded-lg px-3 py-2 hover:bg-muted">
          <Eye className="w-4 h-4" /> Preview
        </button>
      </div>

      <FooterSections
        initialData={initialData}
        onChange={(data) => {
          sectionsRef.current = data;
        }}
      />

      <FormActions
        onCancel={() => navigate("/pages")}
        onPublish={handleSave}
        loading={loading}
        publishLabel={
          <span className="flex items-center gap-2">
            <Save className="w-4 h-4" />
            {loading ? "Saving..." : "Save Footer"}
          </span>
        }
      />
    </div>
  );
}
